import { Component, OnInit } from "@angular/core";
import { format } from "url";

@Component({
  selector: "app-multidatepicker",
  templateUrl: "./multidatepicker.component.html",
  styleUrls: ["./multidatepicker.component.css"],
})
export class MultidatepickerComponent implements OnInit {
  dn: any = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  mn: any = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  d: any = new Date();
  sm: any = "";
  sy: any = "";
  cm: any = this.d.getMonth() + 1;
  cy: any = this.d.getFullYear();
  isCurrentMonth: boolean = false;
  selectedDateArray: any = [];

  constructor() {}

  ngOnInit() {
    let __days = this.d.getDate();
    this.d.setDate(1);
    let __f_d = this.d.getDay();

    let __m = this.d.getMonth();
    let __ctm = __m + 1;
    this.sm = this.mn[__m];

    let __y = this.d.getFullYear();
    this.sy = __y;

    let __pmz = __ctm - 1;
    let __nmz = __ctm + 1;
    let __cmz = __ctm;

    //find no of dates in current, previous & next month
    let __cmd = new Date(__y, __m + 1, 0).getDate();
    let __pmd = new Date(__y, __m, 0).getDate();
    let __nmd = new Date(__y, __m + 2, 0).getDate();

    // finding previous month remaining dates
    let __bd = __pmd - __f_d + 1;

    //finding next month remaining dates
    let __ad = 42 - (__cmd + __f_d);

    for (var i = __bd; i <= __pmd; i++) {
      var ele = document.createElement("div");
      ele.setAttribute("data-id", i + "/" + __pmz + "/" + __y);
      ele.setAttribute("class", "mld-hidden-dates");
      var txt = document.createTextNode(i.toString());
      ele.appendChild(txt);
      document.querySelector(".mld-dates").appendChild(ele);
    }

    var currentDate = (__days + "/" + __cmz + "/" + __y).toString();
    var currentDate_format = (__y + "/" + __cmz + "/" + __days).toString();
    var s: any = [];
    var q: any = [];
    var a: any, b: any;

    s.push(currentDate);
    console.log("new date-->" + s);
   
      localStorage.setItem("selectedDates", s);
      localStorage.setItem("singleDate", s);
      localStorage.setItem("mSingleDate", s);


    
    

    for (var i = 1; i <= __cmd; i++) {
      var ele = document.createElement("div");
      ele.setAttribute("data-id", i + "/" + __cmz + "/" + __y);
      ele.setAttribute("data-format", __y + "/" + __cmz + "/" + i);
      ele.setAttribute("class", "mlt-dts");
      var x = ele.getAttribute("data-id");
      var y = ele.getAttribute("data-format");
      if (currentDate === x) {
        ele.setAttribute("class", "mlt-dts mlt-active");
        ele.setAttribute("data-selected", "true");
      }

      if (new Date(y) < new Date(currentDate_format)) {
        ele.setAttribute("class", "mlt-dts mlt-disabled");
      }

      ele.addEventListener("click", function (e) {
        a = this.dataset.id;
        b = this.hasAttribute("data-selected");
        if (!b) {
          this.setAttribute("data-selected", "true");
          this.setAttribute("class", "mlt-dts mlt-active");
          s.push(a);
          localStorage.setItem("selectedDates", s);
          localStorage.setItem("singleDate", s);
          localStorage.setItem("mSingleDate", s);


          console.log("Selected date", s);
        } else {
          this.removeAttribute("data-selected");
          this.setAttribute("class", "mlt-dts");
          var l = localStorage.getItem("selectedDates").split(",");
          var m = localStorage.getItem('singleDate').split(",");
          var n = localStorage.getItem('mSingleDate').split(",");

          s = l.filter((s: any) => s !== a);
          s = m.filter((s:any) => s !== a);
          q = n.filter((s:any) => s !== a);

          localStorage.setItem("selectedDates", s);
          localStorage.setItem("singleDate", s);
         localStorage.setItem("mSingleDate", q);
    
          
        }
      });

      var txt = document.createTextNode(i.toString());
      ele.appendChild(txt);
      document.querySelector(".mld-dates").appendChild(ele);
    }

    console.log("S ---> ", s);
    this.selectedDateArray = s;
    console.log("Current date selection", this.selectedDateArray);

    for (var i = 1; i <= __ad; i++) {
      var ele = document.createElement("div");
      ele.setAttribute("data-id", i + "/" + __nmz + "/" + __y);
      ele.setAttribute("class", "mld-hidden-dates");
      var txt = document.createTextNode(i.toString());
      ele.appendChild(txt);
      document.querySelector(".mld-dates").appendChild(ele);
    }
  }

  nextMonth() {
    var prevMonthSelectedDtaes = localStorage
      .getItem("selectedDates")
      .split(",");

    let __m = this.d.getMonth() + 1;
    this.d.setMonth(__m);
    let __mc = this.d.getMonth();
    let __ctm = this.d.getMonth() + 1;
    this.sm = this.mn[__mc];

    let __y = this.d.getFullYear();
    this.sy = __y;

    this.d.setDate(1);
    let __f_d = this.d.getDay();
    let __fd = this.dn[__f_d];

    let __pmz = __ctm - 1;
    let __nmz = __ctm + 1;
    let __cmz = __ctm;

    var __bd, __ad;

    //find no of dates in current, previous & next month
    let __cmd = new Date(__y, __m + 1, 0).getDate();
    let __pmd = new Date(__y, __m, 0).getDate();
    let __nmd = new Date(__y, __m + 2, 0).getDate();

    if (__f_d == 0) {
      __bd = __pmd - 7 + 1;
      __ad = 42 - (__cmd + 7);
    } else {
      __bd = __pmd - __f_d + 1;
      __ad = 42 - (__cmd + __f_d);
    }

    if (parseInt(__ctm) > parseInt(this.cm)) {
      // alert(1);
      this.isCurrentMonth = false;
    } else{
      // alert(2);
      this.isCurrentMonth = false
    }
    this.isCurrentMonth = false;


    var remove = document.querySelector(".mld-dates");
    while (remove.lastElementChild) {
      remove.removeChild(remove.lastElementChild);
    }

    console.log(__bd + "----" + __pmd + "---" + __f_d);

    var a: any, b: any;

    for (var i = __bd; i <= __pmd; i++) {
      var ele = document.createElement("div");
      ele.setAttribute("data-id", i + "/" + __pmz + "/" + __y);
      ele.setAttribute("class", "mld-hidden-dates");
      var txt = document.createTextNode(i.toString());
      ele.appendChild(txt);
      document.querySelector(".mld-dates").appendChild(ele);
    }

    for (var i: any = 1; i <= __cmd; i++) {
      var ele = document.createElement("div");
      ele.setAttribute("data-id", i + "/" + __cmz + "/" + __y);
      ele.setAttribute("class", "mlt-dts");
      var x = ele.getAttribute("data-id");
      var txt = document.createTextNode(i.toString());
      ele.appendChild(txt);
      document.querySelector(".mld-dates").appendChild(ele);

      ele.addEventListener("click", function (e) {
        a = this.dataset.id;
        b = this.hasAttribute("data-selected");
        if (!b) {
          this.setAttribute("data-selected", "true");
          this.setAttribute("class", "mlt-dts mlt-active");
          prevMonthSelectedDtaes.push(a);
          localStorage.setItem(
            "selectedDates",
            prevMonthSelectedDtaes.toString()
          );
        } else {
          this.removeAttribute("data-selected");
          this.setAttribute("class", "mlt-dts");
          var l = localStorage.getItem("selectedDates").split(",");
          prevMonthSelectedDtaes = l.filter((s: any) => s !== a);
          localStorage.setItem(
            "selectedDates",
            prevMonthSelectedDtaes.toString()
          );
        }
      });
    }

    var mld = document.getElementsByClassName("mlt-dts");
    var sdt = localStorage.getItem("selectedDates").split(",");

    for (var i: any = 0; i < mld.length; i++) {
      console.log(mld[i].getAttribute("data-id"));
      var wd = mld[i].getAttribute("data-id");
      for (var j = 0; j < sdt.length; j++) {
        if (mld[i].getAttribute("data-id") === sdt[j]) {
          mld[i].setAttribute("data-selected", "true");
          mld[i].setAttribute("class", "mlt-dts mlt-active");
        }
      }
    }

    for (var i: any = 1; i <= __ad; i++) {
      var ele = document.createElement("div");
      ele.setAttribute("data-id", i + "/" + __nmz + "/" + __y);
      ele.setAttribute("class", "mld-hidden-dates");
      var txt = document.createTextNode(i.toString());
      ele.appendChild(txt);
      document.querySelector(".mld-dates").appendChild(ele);
    }
  }

  previousMonth() {
  // this.isCurrentMonth = false;

    var prevMonthSelectedDtaes = localStorage
      .getItem("selectedDates")
      .split(",");

    let __m = this.d.getMonth() - 1;
    this.d.setMonth(__m);
    let __mc = this.d.getMonth();
    let __ctm = this.d.getMonth() + 1;
    this.sm = this.mn[__mc];

    let __y = this.d.getFullYear();
    this.sy = __y;

    this.d.setDate(1);
    let __f_d = this.d.getDay();
    let __fd = this.dn[__f_d];

    let __pmz = __ctm - 1;
    let __nmz = __ctm + 1;
    let __cmz = __ctm;

    var __bd, __ad;

    //find no of dates in current, previous & next month
    let __cmd = new Date(__y, __m + 1, 0).getDate();
    let __pmd = new Date(__y, __m, 0).getDate();
    let __nmd = new Date(__y, __m + 2, 0).getDate();

    if (__f_d == 0) {
      __bd = __pmd - 7 + 1;
      __ad = 42 - (__cmd + 7);
    } else {
      __bd = __pmd - __f_d + 1;
      __ad = 42 - (__cmd + __f_d);
    }
    console.log("if cond check--->" , __ctm , '----' , parseInt(this.cm));
    console.log("if cond check2--->" , __y , '----' , parseInt(this.cy));

    if (
      parseInt(__ctm) === parseInt(this.cm) &&
      parseInt(__y) === parseInt(this.cy)
    ) {
      this.isCurrentMonth = true;
    } else {
      this.isCurrentMonth = false;
    }



    var remove = document.querySelector(".mld-dates");
    while (remove.lastElementChild) {
      remove.removeChild(remove.lastElementChild);
    }

    console.log(__bd + "----" + __pmd + "---" + __f_d);
    console.log("curr month---->",this.isCurrentMonth);

    var a: any, b: any;

    for (var i = __bd; i <= __pmd; i++) {
      var ele = document.createElement("div");
      ele.setAttribute("data-id", i + "/" + __pmz + "/" + __y);
      ele.setAttribute("class", "mld-hidden-dates");
      var txt = document.createTextNode(i.toString());
      ele.appendChild(txt);
      document.querySelector(".mld-dates").appendChild(ele);
    }

    for (var i: any = 1; i <= __cmd; i++) {
      var ele = document.createElement("div");
      ele.setAttribute("data-id", i + "/" + __cmz + "/" + __y);
      ele.setAttribute("data-format", __y + "/" + __cmz + "/" + i);
      ele.setAttribute("class", "mlt-dts");
      var x = ele.getAttribute("data-id");
      var txt = document.createTextNode(i.toString());
      ele.appendChild(txt);
      document.querySelector(".mld-dates").appendChild(ele);

      ele.addEventListener("click", function (e) {
        a = this.dataset.id;
        b = this.hasAttribute("data-selected");
        if (!b) {
          this.setAttribute("data-selected", "true");
          this.setAttribute("class", "mlt-dts mlt-active");
          prevMonthSelectedDtaes.push(a);
          localStorage.setItem(
            "selectedDates",
            prevMonthSelectedDtaes.toString()
          );
        } else {
          this.removeAttribute("data-selected");
          this.setAttribute("class", "mlt-dts");
          var l = localStorage.getItem("selectedDates").split(",");
          prevMonthSelectedDtaes = l.filter((s: any) => s !== a);
          localStorage.setItem(
            "selectedDates",
            prevMonthSelectedDtaes.toString()
          );
        }
      });
    }

    var mld = document.getElementsByClassName("mlt-dts");
    var sdt = localStorage.getItem("selectedDates").split(",");
    var tday = localStorage.getItem("todayDate").split("/").reverse().join("-");

    for (var i: any = 0; i < mld.length; i++) {
      console.log(mld[i].getAttribute("data-id"));
      var wd = mld[i].getAttribute("data-format");
      if (new Date(wd) < new Date(tday)) {
        mld[i].setAttribute("class", "mlt-dts mlt-disabled");
      }
    }

    for (var i: any = 0; i < mld.length; i++) {
      console.log(mld[i].getAttribute("data-id"));
      var wd = mld[i].getAttribute("data-id");
      for (var j = 0; j < sdt.length; j++) {
        if (mld[i].getAttribute("data-id") === sdt[j]) {
          mld[i].setAttribute("data-selected", "true");
          mld[i].setAttribute("class", "mlt-dts mlt-active");
        }
      }
    }

    for (var i: any = 1; i <= __ad; i++) {
      var ele = document.createElement("div");
      ele.setAttribute("data-id", i + "/" + __nmz + "/" + __y);
      ele.setAttribute("class", "mld-hidden-dates");
      var txt = document.createTextNode(i.toString());
      ele.appendChild(txt);
      document.querySelector(".mld-dates").appendChild(ele);
    }
  }

}
